module.exports = __webpack_public_path__ + "img/icon_close.5c0d9344.svg";